import { useState, useEffect } from "react";

type ThemeName = "light" | "dark-blue-violet";

const THEME_STORAGE_KEY = "quizrun-theme";
const DEFAULT_THEME: ThemeName = "light";

const themes = [
  { name: "light" as ThemeName, label: "Light Mode" },
  { name: "dark-blue-violet" as ThemeName, label: "Dark Mode" },
];

const getStoredTheme = (): ThemeName => {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  // Migrate old theme names
  if (stored === "blue-violet") return "light";
  if (stored && themes.some((t) => t.name === stored)) {
    return stored as ThemeName;
  }
  return DEFAULT_THEME;
};

export const useTheme = () => {
  const [activeTheme, setActiveTheme] = useState<ThemeName>(getStoredTheme);

  useEffect(() => {
    document.documentElement.classList.remove("dark-blue-violet");
    if (activeTheme === "dark-blue-violet") {
      document.documentElement.classList.add("dark-blue-violet");
    }
    // "light" uses :root defaults, no class needed
    localStorage.setItem(THEME_STORAGE_KEY, activeTheme);
  }, [activeTheme]);

  return { activeTheme, setActiveTheme, themes };
};
